<template>
    <div>
        <Layout>
            <template v-slot:default>
                <div class="bg-white rounded-lg shadow-md p-6 mt-32">
                    <div class="items-center justify-center text-center">
                        <h2 class="text-6xl font-semibold text-main-text mb-5">
                            Government Authorized Course
                        </h2>
                        <hr class="w-20 h-1 mx-auto my-4 -mt-3 bg-main-orange border-0 rounded md:my-6 dark:bg-gray-700" />
                    </div>
                    <div class="
                                                flex
                                                items-center
                                                justify-center
                                                text-center
                                                mb-8
                                                rounded-lg
                                              ">
                        <img class="w-full rounded-lg shadow-md max-w-4xl"
                            src="https://images.pexels.com/photos/3822718/pexels-photo-3822718.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                            alt="Dr. Manisha's Yoga Institute" />
                    </div>
                    <div class="max-w-3xl mx-auto my-8">
                        <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                            Yoga Instructor Course
                        </h2>
                        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2">
                            Vyasa Bangalore, recognized by Ayush Gov. of India
                        </h3>
                        <p class="text-gray-700 dark:text-gray-400 mb-4">
                            Give your career a new direction!!!
                        </p>
                        <div class="mb-4 flex items-center">
                            <div class="mr-2 flex items-center">
                                <i class="fas fa-star text-yellow-300"></i>
                                <i class="fas fa-star text-yellow-300"></i>
                                <i class="fas fa-star text-yellow-300"></i>
                                <i class="fas fa-star text-yellow-300"></i>
                                <i class="fas fa-star text-gray-300"></i>
                            </div>
                            <span class="text-gray-600 text-sm">(3,840)</span>
                        </div>
                        <ul class="list-disc list-inside mb-4">
                            <li>Unique and powerful course design by Vyasa.</li>
                            <li>
                                Teaching yoga by anatomical and physiological aspects and advanced
                                meditation.
                            </li>
                            <li>Micro teaching.</li>
                            <li>Theory and practical knowledge.</li>
                            <li>Increases ability to take good classes.</li>
                        </ul>
                        <p class="text-gray-700 dark:text-gray-400 mb-4">
                            <strong>Duration:</strong> 3 months
                        </p>
                        <p class="text-gray-700 dark:text-gray-400 mb-4">
                            <strong>Eligibility:</strong> 10th standard or equivalent
                        </p>
                        <div class="mb-4">
                            <p class="text-gray-700 dark:text-gray-400 mb-2">
                                <strong>Contact Details:</strong>
                            </p>
                            <p class="text-gray-700 dark:text-gray-400 mb-1">
                                Phone: <a class="text-main-orange" href="tel:8308315494">830 831 5494</a> / <a
                                    class="text-main-orange" href="tel:9422017342">942 2017 342</a>
                            </p>
                            <p class="text-gray-700 dark:text-gray-400 mb-1">
                                Email: <a class="text-main-orange"
                                    href="mailto:drmanishas777@gmail.com">drmanishas777@gmail.com</a>
                            </p>

                        </div>
                    </div>
                    <div
                        class="bg-main-bg bg-opacity-20 backdrop-filter backdrop-blur-lg backdrop-saturate-150 rounded-lg shadow-md p-6 mt-8 max-w-md mx-auto">
                        <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">Enroll Now - <em>Yoga Instructor
                                Certification Course</em></h2>
                        <form @submit.prevent="submitForm" method="POST">
                            <div class="mb-4">
                                <label class="block text-gray-700 dark:text-gray-400 mb-2" for="full_name">
                                    Full Name<span class="text-red-500">*</span>
                                </label>
                                <input v-model="fullName"
                                    class="form-input rounded-md shadow-sm border-gray-300 focus:border-main-orange focus:ring focus:ring-main-orange focus:ring-opacity-50 w-full"
                                    id="full_name" name="full_name" type="text" placeholder="Enter your full name">
                                <p v-if="formErrors.fullName" class="text-red-500">{{ formErrors.fullName }}</p>
                            </div>
                            <div class="mb-4">
                                <label class="block text-gray-700 dark:text-gray-400 mb-2" for="email">
                                    Email Address<span class="text-red-500">*</span>
                                </label>
                                <input v-model="email"
                                    class="form-input rounded-md shadow-sm border-gray-300 focus:border-main-orange focus:ring focus:ring-main-orange focus:ring-opacity-50 w-full"
                                    id="email" name="email" type="email" placeholder="Enter your email address">
                                <p v-if="formErrors.email" class="text-red-500">{{ formErrors.email }}</p>
                            </div>
                            <div class="mb-4">
                                <label class="block text-gray-700 dark:text-gray-400 mb-2" for="phone">
                                    Phone Number<span class="text-red-500">*</span>
                                </label>
                                <input v-model="phone"
                                    class="form-input rounded-md shadow-sm border-gray-300 focus:border-main-orange focus:ring focus:ring-main-orange focus:ring-opacity-50 w-full"
                                    id="phone" name="phone" type="tel" placeholder="Enter your phone number">
                                <p v-if="formErrors.phone" class="text-red-500">{{ formErrors.phone }}</p>
                            </div>
                            <div class="mb-4">
                                <label class="block text-gray-700 dark:text-gray-400 mb-2" for="message">
                                    Message (optional)
                                </label>
                                <textarea v-model="message"
                                    class="form-textarea rounded-md shadow-sm border-gray-300 focus:border-main-orange focus:ring focus:ring-main-orange focus:ring-opacity-50 w-full"
                                    id="message" name="message" placeholder="Enter your message"></textarea>
                            </div>
                            <button
                                class="bg-main-orange hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded w-full transition-colors duration-300 ease-in-out"
                                type="submit">Enroll Now</button>
                        </form>
                    </div>




                </div>

            </template>
        </Layout>
    </div>
</template>

<script>
import Layout from '../Layout/Layout.vue';
import Swal from 'sweetalert2';
import axios from 'axios';
import { API_URL } from '@/config';
import emailjs from 'emailjs-com';

export default {
    name: "YogaInstructor",
    components: { Layout },
    metaInfo() {
        return {
            title: 'Yoga Instructor Certification Course | Dr. Manishas Yoga Institute',
            meta: [
                {
                    name: 'description',
                    content: 'Yoga Instructor Certification Course by Dr. Manishas Yoga Institute. Get certified as a yoga instructor and start your career in yoga.'
                },
                {
                    name: 'keywords',
                    content: 'yoga instructor certification course, yoga instructor course, yoga instructor training, yoga instructor course in bangalore, yoga instructor course in india, yoga instructor course in pune, yoga instructor course in mumbai, yoga instructor course in delhi, yoga instructor course in hyderabad, yoga instructor course in chennai, yoga instructor course in kolkata, yoga instructor course in ahmedabad, yoga instructor course in jaipur, yoga instructor course in lucknow, yoga instructor course in kanpur, yoga instructor course in nagpur, yoga instructor course in patna, yoga instructor course in bhopal, yoga instructor course in indore, yoga instructor course in vadodara, yoga instructor course in varanasi, yoga instructor course in surat, yoga instructor course in ghaziabad, yoga instructor course in ludhiana, yoga instructor course in agra, yoga instructor course in dhanbad, yoga instructor course in amritsar, yoga instructor course in nashik, yoga instructor course in faridabad, yoga instructor course in meerut, yoga instructor course in rajkot, yoga instructor course in kota, yoga instructor course in bhubaneswar, yoga instructor course in jodhpur, yoga instructor course in coimbatore, yoga instructor course in gwalior, yoga instructor course in chandigarh, yoga instructor course in thiruvananthapuram, yoga instructor course in bikaner, yoga instructor course in allahabad, yoga instructor course in madurai, yoga instructor course in raipur, yoga instructor course in guwahati, yoga instructor course in jalandhar, yoga instructor course in tiruchirappalli, yoga instructor course in bhiwandi, yoga instructor course in salem, yoga instructor course in warangal, yoga instructor course in kochi, yoga instructor course in hubli, yoga instructor course in mysore, yoga instructor course in navi mumbai, yoga instructor course in gurgaon, yoga instructor course in amravati, yoga instructor course in noida, yoga instructor course in jamshedpur, yoga instructor course in bhilai, yoga instructor course in cutt'
                },
            ]
        }
    },
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            message: '',
            formErrors: {},
        };
    },
    methods: {
        validateForm() {
            let isValid = true;
            this.formErrors = {};

            if (!this.fullName) {
                this.formErrors.fullName = 'Please enter your full name';
                isValid = false;
            }

            if (!this.email) {
                this.formErrors.email = 'Please enter your email address';
                isValid = false;
            } else if (!/\S+@\S+\.\S+/.test(this.email)) {
                this.formErrors.email = 'Please enter a valid email address';
                isValid = false;
            }

            if (!this.phone) {
                this.formErrors.phone = 'Please enter your phone number';
                isValid = false;
            } else if (!/^\d{10}$/.test(this.phone)) {
                this.formErrors.phone = 'Please enter a valid phone number';
                isValid = false;
            }

            return isValid;
        },

        async submitForm() {
            try {
                if (this.validateForm()) {
                    // Make API call to submit form data
                    await axios.post('https://formspree.io/f/xzblppkd', {
                        fullName: this.fullName,
                        email: this.email,
                        phone: this.phone,
                        message: this.message
                    });

                    // Save form data to MongoDB
                    await axios.post(`${API_URL}/api/yogainstructorform`, {
                        fullName: this.fullName,
                        email: this.email,
                        phone: this.phone,
                        message: this.message
                    });
                    // add a loading untill we see show success message
                    await Swal.fire({
                        title: 'Please wait...',
                        html: 'We are submitting your form',
                        onBeforeOpen: () => {
                            Swal.showLoading();
                        },
                        showConfirmButton: false,
                        showCancelButton: false,
                        showDenyButton: false,
                        type: 'success',
                        timer: 2000

                    });

                    // Send email to user
                    const emailParams = {
                        fullName: this.fullName,
                        to_email: this.email,
                        from_email: 'drmanishas777@gmail.com',
                        // from_name: "Dr. Manisha's Yoga Institute",

                    }
                    const emailResponse = await emailjs.send(
                        'service_91st2jd',
                        'template_wbrac8d',
                        emailParams,
                        'toWDk4koE8-1VmUIV'
                    )
                    console.log(emailResponse);


                    // Show success message
                    await Swal.fire({
                        icon: 'success',
                        title: 'Yoga Instructor Certification Course',
                        text: `Thank you ${this.fullName} for enrolling!`
                    });
                    // Clear form
                    this.fullName = '';
                    this.email = '';
                    this.phone = '';
                    this.message = '';

                }
            } catch (error) {
                // Show error message
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Something went wrong. Please try again later.'
                });
            }
        }
    }

}
</script>